import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Links extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Links";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      name: null,
      description: null,
      label: null,
      link: null,
      markup: '<b><font size="3">Create Link Content</font></b><div><font size="2">Use this editor to manually create link content</font></div>',
      use_markup: true,
      is_required: false,
      required_label: null,
      mid_id: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    // use this for transforming your data, e.g. transform a Date-string into a Date object; see: https://vuex.feathersjs.com/model-classes.html#setupinstance
    return data;
  }
}
